import React from 'react';
import { motion } from 'framer-motion';

const FFSlideOverviewVideo: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center h-full px-16 py-8">
      <motion.h2
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-4xl font-bold text-white mb-2 text-center"
      >
        Lumen8 Overview
      </motion.h2>
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.2 }}
        className="text-base text-[#94a3b8] mb-6 text-center"
      >
        A quick introduction to the platform
      </motion.p>

      <motion.div
        initial={{ opacity: 0, scale: 0.97 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.3 }}
        className="w-full max-w-5xl rounded-xl overflow-hidden"
        style={{
          aspectRatio: '1920 / 1080',
          border: '1px solid rgba(255, 255, 255, 0.15)',
          boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)',
          background: 'rgba(0, 0, 0, 0.4)',
        }}
      >
        <iframe
          src="https://share.synthesia.io/embeds/videos/fb73999a-7d1a-40ce-9191-6f285d173a24"
          loading="lazy"
          title="Synthesia video player - Lumen8 Overview"
          allowFullScreen
          allow="encrypted-media; fullscreen; microphone; screen-wake-lock;"
          style={{
            width: '100%',
            height: '100%',
            border: 'none',
            display: 'block',
          }}
        />
      </motion.div>
    </div>
  );
};

export default FFSlideOverviewVideo;
